module.exports = __webpack_public_path__ + "static/media/404-error.cba0c7f3.jpeg";